import { Col, Row } from "react-bootstrap";

export default function LogoMascot() {
  return (
    <div
      style={{
        lineHeight: "2",
        padding: "20px",
        border: "1px solid #ddd",
        borderRadius: "8px",
      }}
    >
      {/* Tournament Logo Section */}

      <div style={{ lineHeight: "2" }}>
        <h3>Official Logo</h3>
        <br />
        <Row>
          <Col md={8}>
            {/* key symbolism */}
            <p style={{ textAlign: "justify", marginBottom: "15px" }}>
              Asia Rugby U20 Sevens Rajgir, Bihar – A Living Symbol of Bihar’s
              Heritage and Sporting Spirit
            </p>
            <p style={{ textAlign: "justify", marginBottom: "15px" }}>
              The logo of the Asia Rugby U20 Sevens, to be held in Rajgir
              (Bihar), is a vibrant representation of the state’s historical
              legacy, cultural diversity, and sporting spirit.
            </p>
            <p style={{ textAlign: "justify", marginBottom: "15px" }}>
              BIHAR — more than just five letters, it is a visual identity of
              Bihar’s soul. Each letter stands as a symbol, narrating stories
              from the state’s cultural, historical, and natural heritage.
            </p>
          </Col>
          <Col md={4}>
            <img
              src="./img/AsiaRugbyU207s/logo.png"
              alt="Description"
              style={{ width: "100%", height: "auto", objectFit: "cover" }}
            />
          </Col>
        </Row>
        <br />
        <h4 style={{ textAlign: "justify" }}>
          Symbolic Meaning of Each Letter:
        </h4>
        <br />
        <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
          <li style={{ listStyleType: "disc" }}>
            <b>B – Buddha and the Bodhi Tree :</b>
            <p>
              This letter represents Bodh Gaya and Lord Buddha, where he
              attained enlightenment. It symbolizes Bihar’s spiritual legacy and
              its universal message of peace.
            </p>
          </li>
          <li style={{ listStyleType: "disc" }}>
            <b>I – River and Chhath Puja :</b>
            <p>
              This letter illustrates the river Ganga, Bihar’s lifeline, and the
              emotional essence of Chhath Puja. It stands for devotion,
              connection with nature, and cultural pride.
            </p>
          </li>
          <li style={{ listStyleType: "disc" }}>
            <b>H – Harvesting Crops</b>
            <p>
              A farmer harvesting crops is depicted here — honoring Bihar’s
              agricultural richness, the hard-working rural life, and its
              leading role in horticultural production.
            </p>
          </li>
          <li style={{ listStyleType: "disc" }}>
            <b>A – Gaur and Sparrow :</b>
            <p>
              The Indian Gaur (state animal) and Sparrow (state bird) are
              featured in this letter, representing Bihar’s biodiversity,
              ecological balance, and natural abundance.
            </p>
          </li>
          <li style={{ listStyleType: "disc" }}>
            <b>R – Ruins of Ancient Universities:</b>
            <p>
              This letter draws from the architectural heritage of Nalanda and
              Vikramshila universities. It reflects Bihar’s ancient education
              systems, intellectual tradition, and its global knowledge legacy.
            </p>
          </li>
        </ul>
        <br />
        <h5 style={{ textAlign: "justify" }}>Color Palette and Essence:</h5>
        <br />
        <p style={{ textAlign: "justify" }}>
          The colors used — blue, green, and terracotta — express Bihar’s
          natural beauty, cultural richness, and vital energy.
        </p>
        <p style={{ textAlign: "justify" }}>
          The modern linework gives it a contemporary look, while the symbolism
          adds depth.
        </p>
        <p style={{ textAlign: "justify" }}>
          This logo is not just a mark of identity, but a creative reflection of
          Bihar’s spirit — a beautiful blend of tradition and modernity.
        </p>
        <br />
      </div>

      {/* Mascot Section */}

      <div style={{ marginBottom: "30px" }}>
        <h2 style={{ fontSize: "22px", marginBottom: "15px" }}>
          Ashoka – The Official Mascot of Asia Rugby U20 Sevens Bihar
        </h2>
        <p style={{ textAlign: "justify", marginBottom: "15px" }}>
          Presenting Ashoka, the official mascot of the Asia Rugby U20 Sevens
          Championship to be held in Rajgir, Bihar.
        </p>
        <Row style={{ marginBottom: "0px" }}>
          <Col md={8}>
            <ul style={{ paddingLeft: "20px", textAlign: "justify" }}>
              <li style={{ listStyleType: "disc" }}>
                Named after Emperor Ashoka, he symbolizes leadership, foresight,
                and transformation. His name is not just a reminder of our proud
                history, but also a reflection of the spirit of the sport —
                discipline, courage, and determination.
              </li>
              <li style={{ listStyleType: "disc" }}>
                Ashoka takes the form of a rabbit — fast, alert, and agile.
                These are the very qualities that define rugby: quick reflexes,
                relentless pace, and sharp strategy.
              </li>
              <li style={{ listStyleType: "disc" }}>
                His armour, helmet, and shield stand for readiness, inner
                strength, and mental resilience. The rugby ball in his hand
                signifies that his battlefield is now the game — where every
                move demands bravery, grit, and smart tactics.
              </li>
            </ul>
          </Col>
          <Col md={4}>
            <img
              src="./img/AsiaRugbyU207s/mascot.png"
              alt="Description"
              style={{ width: "100%", height: "auto", objectFit: "cover" }}
            />
          </Col>
        </Row>
        <p style={{ textAlign: "justify" }}>
          Ashoka is more than just a mascot. He is a symbol — that Bihar is not
          just rooted in history, but poised to lead the future of sports. He
          embodies the spirit of youth, Bihar’s rising ambition, and the energy
          of this championship.
        </p>
      </div>
    </div>
  );
}
